import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'dk-auth-logout-callback',
  standalone: true,
  imports: [CommonModule],
  template: ``,
  styles: []
})
export class LogoutCallbackComponent implements OnInit {
  constructor(private identityAuth: AuthService) { }

  async ngOnInit() {
    await this.identityAuth.completeLogout();
  }
}
